// src/modal/Modal.tsx
import React from "react";
import { X } from "lucide-react";
import { theme } from "../../../theme/tokens";

const Modal: React.FC<{
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}> = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-bg-overlay"
    >
      <div
        className="w-full max-w-md max-h-[90vh] overflow-y-auto p-6 bg-bg-surface rounded-xl shadow-lg relative border border-border-default"
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
      >
        <button
          className="absolute top-3 right-3 text-text-muted hover:text-ds-status-error-main transition-colors"
          onClick={onClose}
          aria-label="Close modal"
          type="button"
        >
          <X size={20} />
        </button>
        {title && <h3 className="text-lg font-bold mb-4 text-text-primary">{title}</h3>}
        {children}
      </div>
    </div>
  );
};

export default Modal;
